export default "/_next/static/images/47ccf0212b26c003ed0846738c971755.png";